@if (job) {
  <div class="position--border">
    <figure>
      <a [routerLink]="['job', (job.name | seoUrl), job.id]">
        <img [attr.src]="'/assets/i/job-images/'+job.jobImage" alt="">
      </a>
    </figure>
    <div class="position__text">
      <h2><a [routerLink]="['job', (job.name | seoUrl), job.id]">{{job.name}}</a></h2>
      <span>{{job.industry.label| translate}} - {{job.location.country.toUpperCase()| translate}}</span>
    </div>
  </div>
}
